module.exports = __webpack_public_path__ + "img/eye-close.031cd037.svg";